export default "__VITE_ASSET__ZY5mFGic__"